module.exports = __webpack_public_path__ + "img/3.0a983612.png";